import React, { useEffect, useState } from 'react'
import { HeaderImport } from './Import'
const { RoutesMap, FaFacebookF, FaInstagram, FaLinkedinIn, FaPinterestP, Button, Navbar, Nav, Dropdown, AOS, useNavigate, Link, Logo, KeyRound, Power, UserPen, Languages, useDispatch, toggleChangePasswordModal, ChangePassword, img_nf, useTranslation } = HeaderImport

export default function LandingPageHeader() {

    const [isSticky, setSticky] = useState(false)
    const { t, i18n } = useTranslation()
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const user_data = JSON.parse(localStorage.getItem('user_data'))
    const user_details = JSON.parse(localStorage.getItem('user_details'))
    const token = localStorage.getItem('user_token')

    const lang_option = {
        items: [
            { key: 'en', label: 'English' },
            { key: 'hi', label: 'Hindi' },
            { key: 'ar', label: 'Arabic' },
            { key: 'md', label: 'Mandarin' },
            { key: 'gm', label: 'German' },
            { key: 'fr', label: 'French' },
            { key: 'rs', label: 'Russian' },
            { key: 'it', label: 'Italian' },
        ],
        selectable: true,
        defaultSelectedKeys: [i18n?.language],
        onClick: ({ key }) => {
            i18n.changeLanguage(key)
        },
    };

    const settings_option = [
        {
            key: '1',
            label: 'Profile',
            icon: <UserPen size={16} />,
            onClick: () => navigate('/profile')
        },
        {
            key: '2',
            label: 'Change Password',
            icon: <KeyRound size={16} />,
            onClick: () => changePasswordModal()
        },
        {
            type: 'divider',
        },
        {
            key: '3',
            label: 'Log Out',
            icon: <Power size={16} />,
            onClick: () => logout()
        },
    ];

    const login_option = [
        {
            key: '1',
            label: (
                <div className="d-flex align-items-center">
                    <h6 className="p-2 flex-grow-1">{t('registration.participant')}</h6>
                    <Button variant="outline-primary" size='sm' className='outline_orange me-2' onClick={() => navigate(RoutesMap.LOGIN.path)}>
                        {t('common.login')}
                    </Button>
                    <Button variant="outline-success" size='sm' className='outline_orange me-2' onClick={() => navigate(RoutesMap.PARTICIPANT_SIGN_UP.path)}>
                        {t('common.sign_up')}
                    </Button>
                </div>
            ),
        },
        {
            key: '2',
            label: (
                <div className="d-flex align-items-center">
                    <h6 className="p-2 flex-grow-1">{t('registration.organizer')}</h6>
                    <Button variant="outline-primary" size='sm' className='outline_orange me-2' onClick={() => window.open(process.env.REACT_APP_BASE_URL + 'admin/organizer-login', '_blank')}>
                        {t('common.login')}
                    </Button>
                    <Button variant="outline-success" size='sm' className='outline_orange me-2' onClick={() => navigate(RoutesMap.ORGANIZATION_SIGN_UP.path)}>
                        {t('common.sign_up')}
                    </Button>
                </div>
            ),
        },
    ];

    const changePasswordModal = () => dispatch(toggleChangePasswordModal())

    const logout = () => {
        localStorage.clear()
        navigate(RoutesMap.LOGIN.path)
    }

    useEffect(() => {

        AOS.init();

        const handleScroll = () => {
            setSticky(window.scrollY > 50);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <>
            <Navbar
                expand="lg"
                className={`header_area ${isSticky ? 'sticky' : ''}`}
                fixed="top"
                data-aos="fade-down"
                data-aos-duration="1000"
            >
                <div className="container d-flex justify-content-between align-items-center">
                    <a className="navbar-brand site_logo" href="/">
                        <img src={Logo} alt="logo" className='img-fluid' />
                    </a>

                    <Nav className="header_links">
                        {/* <Link to="/" className="nav-link">Home</Link> */}
                        <Link to={token ? "/dashboard" : "/login"} className="nav-link">Dashboard</Link>
                        <Link to="/event-list" className="nav-link">Events</Link>
                        <Link to="/buddies" className="nav-link">Buddies</Link>
                        {/* <Link to="/" className="nav-link">Leaderboard</Link> */}
                    </Nav>

                    <div className='d-flex align-items-center'>

                        {!token &&

                            <Dropdown
                                menu={{ items: login_option }}
                                placement="bottom"
                                className='common_btn'
                            >
                                {t('common.login_signup')}
                            </Dropdown>

                        }

                        <span className='text-body-tertiary ms-3 me-3'>|</span>

                        <Dropdown
                            menu={lang_option}
                            placement="bottom"
                        >
                            <Languages size={20} style={{ cursor: 'pointer' }} />
                        </Dropdown>

                        <span className='text-body-tertiary ms-3 me-3'>|</span>

                        <div className='social-icons' onClick={() => window.open("https://www.facebook.com/share/1CAihyeW9D/", "_blank")}>
                            <FaFacebookF size={18} />
                        </div>
                        <div className='social-icons' onClick={() => window.open("https://www.instagram.com/walkrunrideincelebration?igsh=aXk1dm5wazRhMGVy", "_blank")}>
                            <FaInstagram size={18} />
                        </div>
                        {/* <div className='social-icons'>
                            <FaLinkedinIn size={18} />
                        </div> */}
                        <div className='social-icons' onClick={() => window.open("https://pin.it/70sRTY5XL", "_blank")}>
                            <FaPinterestP size={18} />
                        </div>

                        {token &&
                            <>
                                <span className='text-body-tertiary ms-2 me-2'>|</span>

                                <span className='fw-semibold'>Hello, {user_data?.first_name || ''}! <br /><small className='text-secondary fw-medium' style={{ fontSize: 'small' }}>({user_details?.participant_code || ''})</small></span>

                                <span className='text-body-tertiary ms-2 me-2'>|</span>

                                <Dropdown
                                    menu={{ items: settings_option }}
                                    placement="bottom"
                                >
                                    <img
                                        src={user_data?.profile_img?.includes('googleusercontent.com')
                                            ? user_data?.profile_img
                                            : user_data?.profile_img_url || img_nf}
                                        alt="admin"
                                        className='img-fluid admin_img'
                                        style={{ cursor: 'pointer' }}
                                        onError={(e) => { e.target.onerror = null; e.target.src = img_nf }}
                                    />
                                </Dropdown>
                            </>
                        }
                    </div>
                </div>
            </Navbar>

            <ChangePassword />
        </>
    )
}